/**
 * Who sees the dev panel: __DEV__ builds, or `?dev=1` (or #119's `?tune=1`)
 * on a non-production host (staging, preview, local). Never production.
 */
import { getEnvironmentForHostname } from "../config/api";

export interface GateInput {
  isDev: boolean;
  search?: string | null;
  hostname?: string | null;
}

const FLAG = /[?&](dev|tune)=1(&|$)/;

export function devPanelEnabled(o: GateInput): boolean {
  if (o.isDev) return true;
  if (!FLAG.test(o.search ?? "")) return false;
  return getEnvironmentForHostname(o.hostname) !== "production";
}

export function devPanelEnabledHere(): boolean {
  const loc = typeof window !== "undefined" ? window.location : undefined;
  return devPanelEnabled({
    isDev: typeof __DEV__ !== "undefined" && __DEV__,
    search: loc?.search,
    hostname: loc?.hostname,
  });
}
